import API from "../components/helpers/endpointservice";
import Actions from "./api";

// export const allApplication = (data) => {
//   return (dispatch) => {
//     return new Promise((resolve, reject) => {
//       //Loader true
//       dispatch({ type: "IS_LOADER", data: true });
//       Actions.GET(`${API.GET_ALL_APPLICATION_DETAILS}?Application=${data.application?data.application:''}&SubscriptionStatus=${data.subscriptionStatus?data.subscriptionStatus:""}&SortBy=${data.sortBy?data.sortBy:""}&SortOrder=${data.sortByOrder?data.sortByOrder:""}`).then((res) => {
//         if (res.data !== undefined) {
//           resolve(res.data);
//           dispatch({ type: "IS_LOADER", data: false });
//           return res.data

//         }
//         else {
//           reject(new Error("No data in response"));
//           dispatch({ type: "IS_LOADER", data: false });

//         }
//         //Loader false

//       }).catch((error) => {
//         //Loader false
//         dispatch({ type: "IS_LOADER", data: false });
//         reject(error)
//       });
//     });
//   };
// }

//need to give data as object with id value

export const allApplication = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      // Show loader
      dispatch({ type: "IS_LOADER", data: true });

      // Construct query parameters
      const params = new URLSearchParams({
        Application: data.application || "",
        SubscriptionStatus: data.subscriptionStatus || "",
        SortBy: data.sortBy || "",
        SortOrder: data.sortByOrder || "",
      }).toString();

      let data1 = {
        application: data.application || [],
        subcriptionStatus: data.subscriptionStatus || "",
        sortBy: data.sortBy || "",
        sortOrder: data.sortByOrder || "",
        purchasedDate: data.purchasedDate || null,
      };

      // Make API request with query parameters
      // Actions.POST(`${API.GET_ALL_APPLICATION_DETAILS}?${params}`).then((res) => {
      Actions.POST(`${API.GET_ALL_APPLICATION_DETAILS}`, data1)
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject(new Error("No data in response"));
          }
          // Hide loader
          dispatch({ type: "IS_LOADER", data: false });
        })
        .catch((error) => {
          // Hide loader
          dispatch({ type: "IS_LOADER", data: false });
          reject(error);
        });
    });
  };
};

export const allSubscribeApplication = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      // Show loader
      dispatch({ type: "IS_LOADER", data: true });

      // Construct query parameters
      const params = new URLSearchParams({
        Application: data.application || "",
        SubscriptionStatus: data.subscriptionStatus || "",
        SortBy: data.sortBy || "",
        SortOrder: data.sortByOrder || "",
      }).toString();

      let data1 = {
        application: data.application || [],
        sortBy: data.sortBy || "",
        sortOrder: data.sortByOrder || "",
      };

      // Make API request with query parameters
      Actions.POST(`${API.GET_ALL_SUBSCRIPTION_DETAILS}`, data1)
        .then((res) => {
          // Actions.GET(`${API.GET_ALL_SUBSCRIPTION_DETAILS}?${params}`).then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject(new Error("No data in response"));
          }
          // Hide loader
          dispatch({ type: "IS_LOADER", data: false });
        })
        .catch((error) => {
          // Hide loader
          dispatch({ type: "IS_LOADER", data: false });
          reject(error);
        });
    });
  };
};

export const getApplication = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      //Loader true
      dispatch({ type: "IS_LOADER", data: true });
      Actions.GET(`${API.GET_APPLICATION}?ApplicationId=${id}`)
        .then((res) => {
          if (res.data !== undefined) {
            resolve(res.data);
            console.log(res.data);

            dispatch({ type: "APPLICATION_LOADED_SUCCESS", data: res.data });
            dispatch({ type: "IS_LOADER", data: false });
            return res.data;
          } else {
            reject(new Error("No data in response"));
            dispatch({ type: "IS_LOADER", data: false });
          }
          //Loader false
        })
        .catch((error) => {
          //Loader false
          dispatch({ type: "IS_LOADER", data: false });
          reject(error);
        });
    });
  };
};

//Unassigned users
export const unAssignedUsers = (applicationId,isMultiple=false) => {
  let v2url="";
  if(isMultiple){
    v2url="/unassigned/users/v2"
  }
  else{
    v2url="/unassigned/users-groups"
  }
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      //Loader true
      dispatch({ type: "TABLE_LOADER", data: true });
      Actions.GET(
        `${API.GET_UNASSIGNED_USERS}/${applicationId}${v2url}`
      )
        .then((res) => {
          if (res.data !== undefined) {
            resolve(res.data);
            dispatch({ type: "TABLE_LOADER", data: false });
            return res.data;
          } else {
            reject(new Error("No data in response"));
            dispatch({ type: "TABLE_LOADER", data: false });
          }
          //Loader false
        })
        .catch((error) => {
          //Loader false
          dispatch({ type: "TABLE_LOADER", data: false });
          reject(error);
        });
    });
  };
  // return (dispatch) => {
  //   //Loader true
  //   dispatch({ type: "IS_LOADER", data: true });
  //   Actions.GET(`${API.GET_UNASSIGNED_USERS}/${applicationId}/unassigned/users`).then((res) => {
  //     if (res.data !== undefined) {
  //       dispatch({ type: "APPLICATION_LOADED_SUCCESS", data: res.data });
  //     }
  //     //Loader false
  //     dispatch({ type: "IS_LOADER", data: false });
  //   }).catch((error) => {
  //     //Loader false
  //     dispatch({ type: "IS_LOADER", data: false });
  //   });
  // }
};

//ROLE BASED USERS
export const roleBasedUsers = (applicationId, roleid, data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      //Loader true
      dispatch({ type: "TABLE_LOADER", data: true });

      Actions.GET(
        `${
          API.GET_ROLE_BASED_USERS
        }/${applicationId}/role/${roleid}/users-groups/v2?GenericSearch=${
          data?.GenericSearch ? data.GenericSearch : ""
        }&Name=${data.Name ? data.Name : ""}&Email=${
          data.Email ? data.Email : ""
        }&Type=${data.Type ? data.Type : ""}&SortBy=${
          data.SortBy ? data.SortBy : ""
        }&SortOrder=${data.SortOrder ? data.SortOrder : ""}&PageNumber=${
          data.PageNumber ? data.PageNumber : ""
        }&PageSize=${data.PageSize ? data.PageSize : ""}`
      )
        .then((res) => {
          if (res.data !== undefined) {
            resolve(res.data);
            dispatch({ type: "TABLE_LOADER", data: false });
            return res.data;
          } else {
            reject(new Error("No data in response"));
            dispatch({ type: "TABLE_LOADER", data: false });
          }
          //Loader false
        })
        .catch((error) => {
          //Loader false
          dispatch({ type: "TABLE_LOADER", data: false });
          reject(error);
        });
    });
  };
};

//VALIDATION CHECK
export const validationCheck = (applicationId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      //Loader true
      // dispatch({ type: "IS_LOADER", data: true });
      Actions.GET(
        `${API.VALIDATION_CHECK}/${applicationId}/license/validationcheck`
      )
        .then((res) => {
          if (res.data !== undefined) {
            resolve(res.data);
            dispatch({ type: "IS_LOADER", data: false });
            return res.data;
          } else {
            reject(new Error("No data in response"));
            dispatch({ type: "IS_LOADER", data: false });
            return "Hello";
          }
        })
        .catch((error) => {
          dispatch({ type: "IS_LOADER", data: false });
          reject(error);
        });
    });
  };
};

//License Purchase
export const licensePurchase = (applicationId, licenseCount) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      //Loader true
      dispatch({ type: "IS_LOADER", data: true });
      Actions.PUT(
        `${API.PURCHASE_LICENSE}/${applicationId}/license?licenseCount=${licenseCount}`
      )
        .then((res) => {
          if (res.data !== undefined) {
            resolve(res.data);
          } else {
            reject(new Error("No data in response"));
          }
          //Loader false
          dispatch({ type: "IS_LOADER", data: false });
        })
        .catch((error) => {
          console.log("error", error);
          //Loader false
          dispatch({ type: "IS_LOADER", data: false });
          reject(error);
        });
    });
  };
};

//USER ROLE ASSIGN
export const userRoleAssign = (applicationId, roleId, data, teamId, isSSO) => {
  const ssoURL = isSSO ? "/sso" : "";
  const teamIdParam = teamId ? `?teamId=${teamId}` : "";

  return (dispatch) => {
    return new Promise((resolve, reject) => {
      //Loader true
      dispatch({ type: "TABLE_LOADER", data: true });
      Actions.PUT(
        `${API.USER_ROLE_ASSIGN}/${applicationId}/role/${roleId}/user-group/assign${ssoURL}${teamIdParam}`,
        data
      )
        .then((res) => {
          if (res.data !== undefined) {
            resolve(res.data);
          } else {
            dispatch({ type: "TABLE_LOADER", data: false });
            reject(new Error("No data in response"));
          }
          //Loader false
          dispatch({ type: "TABLE_LOADER", data: false });
        })
        .catch((error) => {
          console.log("error", error);
          //Loader false
          dispatch({ type: "TABLE_LOADER", data: false });
          reject(error);
        });
    });
  };
};
export const userRoleAssignMultiple = (
  applicationId,
  roleId,
  data,
  teamId,
  isSSO
) => {
  const ssoURL = isSSO ? "/sso" : "";
  const teamIdParam = teamId ? `?teamId=${teamId}` : "";

  return (dispatch) => {
    return new Promise((resolve, reject) => {
      //Loader true
      dispatch({ type: "TABLE_LOADER", data: true });
      Actions.PUT(
        `${API.USER_ROLE_ASSIGN}/${applicationId}/multipleroles/user/assign/sso`,
        data
      )
        .then((res) => {
          if (res.data !== undefined) {
            resolve(res.data);
          } else {
            dispatch({ type: "TABLE_LOADER", data: false });
            reject(new Error("No data in response"));
          }
          //Loader false
          dispatch({ type: "TABLE_LOADER", data: false });
        })
        .catch((error) => {
          console.log("error", error);
          //Loader false
          dispatch({ type: "TABLE_LOADER", data: false });
          reject(error);
        });
    });
  };
};

//USER ROLE REMOVE
export const userRemoveTable = (applicationId, roleId, data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      //Loader true
      dispatch({ type: "TABLE_LOADER", data: true });
      Actions.PUT(
        `${API.USER_ROLE_REMOVE}/${applicationId}/role/${roleId}/user-group/remove`,
        data
      )
        .then((res) => {
          if (res.data !== undefined) {
            resolve(res.data);
          } else {
            reject(new Error("No data in response"));
          }
          //Loader false
          dispatch({ type: "TABLE_LOADER", data: false });
        })
        .catch((error) => {
          console.log("error", error);
          //Loader false
          dispatch({ type: "TABLE_LOADER", data: false });
          reject(error);
        });
    });
  };
};

//APPLICATION AUDIT LOG
export const auditLog = (applicationId, data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      //Loader true
      dispatch({ type: "TABLE_LOADER", data: true });
      dispatch({ type: "AUDIT_SUCCESS", data: true });
      Actions.GET(
        `${API.ADIT_LOG}/${applicationId}/audit?action=${
          data?.Action ? data.Action : ""
        }&actionBy=${data?.actionBy ? data.actionBy : ""}&startDate=${
          data?.startDate ? data.startDate : ""
        }&endDate=${data?.endDate ? data.endDate : ""}&specificDate=${
          data?.specificDate ? data?.specificDate : ""
        }&SortBy=${data?.SortBy ? data.SortBy : ""}&SortOrder=${
          data?.SortOrder ? data.SortOrder : ""
        }&PageNumber=${data?.PageNumber ? data.PageNumber : ""}&PageSize=${
          data?.PageSize ? data.PageSize : ""
        }`
      )
        .then((res) => {
          if (res.data !== undefined) {
            resolve(res.data);
            dispatch({ type: "AUDIT_SUCCESS", data: false });
            dispatch({ type: "TABLE_LOADER", data: false });
            return res.data;
          } else {
            reject(new Error("No data in response"));
            dispatch({ type: "AUDIT_SUCCESS", data: false });
            dispatch({ type: "TABLE_LOADER", data: false });
            return "Hello";
          }
        })
        .catch((error) => {
          dispatch({ type: "AUDIT_SUCCESS", data: false });
          dispatch({ type: "TABLE_LOADER", data: false });
          reject(error);
        });
    });
  };
};

export const Unsubscribe = (clientId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      //Loader true
      dispatch({ type: "IS_LOADER", data: true });
      Actions.PUT(`${API.UNSUBSCRIBE}/${clientId}`)
        .then((res) => {
          if (res.data !== undefined) {
            resolve(res.data);
          } else {
            reject(new Error("No data in response"));
          }
          //Loader false
          dispatch({ type: "IS_LOADER", data: false });
        })
        .catch((error) => {
          console.log("error", error);
          //Loader false
          dispatch({ type: "IS_LOADER", data: false });
          reject(error);
        });
    });
  };
};

export const Subscribe = (clientId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      //Loader true
      dispatch({ type: "IS_LOADER", data: true });
      Actions.PUT(`${API.SUBSCRIBE}/${clientId}`)
        .then((res) => {
          if (res.data !== undefined) {
            resolve(res.data);
          } else {
            reject(new Error("No data in response"));
          }
          //Loader false
          dispatch({ type: "IS_LOADER", data: false });
        })
        .catch((error) => {
          console.log("error", error);
          //Loader false
          dispatch({ type: "IS_LOADER", data: false });
          reject(error);
        });
    });
  };
};

export const Trial = (clientId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      //Loader true
      dispatch({ type: "IS_LOADER", data: true });
      Actions.PUT(`${API.TRAIL}/${clientId}`)
        .then((res) => {
          if (res.data !== undefined) {
            resolve(res.data);
          } else {
            reject(new Error("No data in response"));
          }
          //Loader false
          dispatch({ type: "IS_LOADER", data: false });
        })
        .catch((error) => {
          console.log("error", error);
          //Loader false
          dispatch({ type: "IS_LOADER", data: false });
          reject(error);
        });
    });
  };
};

export const GetDetails = (clientId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      // Show loader
      dispatch({ type: "IS_LOADER", data: true });

      // Make API request with query parameters
      Actions.GET(`${API.GET_PRODUCTS_DETAILS}${clientId}`)
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject(new Error("No data in response"));
          }
          // Hide loader
          dispatch({ type: "IS_LOADER", data: false });
        })
        .catch((error) => {
          // Hide loader

          dispatch({ type: "IS_LOADER", data: false });
          reject(error);
        });
    });
  };
};

//TRY OR BUY ANY PRODUCTS.
export const TryOrBuyProducts = (clinetId, data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: "IS_LOADER", data: true });
      Actions.POST(`${API.TRY_OR_BUY_PRODUCTS}${clinetId}`, data)
        .then((res) => {
          if (res.status == 200) {
            dispatch({ type: "IS_LOADER", data: false });
            resolve(res.data);
          } else {
            dispatch({ type: "IS_LOADER", data: false });
          }
        })
        .catch((er) => {
          dispatch({ type: "IS_LOADER", data: false });
        });
    });
  };
};

// export const getApplication = (data) => {
//   return (dispatch) => {
//     //Loader true
//     dispatch({ type: "IS_LOADER", data: true });
//     Actions.POST(`${API.GET_ALL_APPLICATION_DETAILS}`, data).then((res) => {
//       if (res.data !== undefined) {
//         dispatch({ type: "APPLICATION_LOADED_SUCCESS", data: res.data });
//       }
//       //Loader false
//       dispatch({ type: "IS_LOADER", data: false });
//     }).catch((error) => {
//       //Loader false
//       dispatch({ type: "IS_LOADER", data: false });
//     });
//   }
// };

export const getApplicationLicenseStatus = (
  applicationId,
  sortBy,
  sortByOrder
) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      //Loader true
      dispatch({ type: "IS_LOADER", data: true });
      Actions.GET(
        `${API.GET_LICENSE_VIEW_FORM}${applicationId}?sortBy=${sortBy}&sortByOrder=${sortByOrder}`
      )
        .then((res) => {
          if (res.data !== undefined) {
            dispatch({
              type: "APPLICATION_LICENSE_LOADED_SUCCESS",
              data: res.data,
            });
            resolve(res.data);
          } else {
            reject(new Error("No data in response"));
          }
          //Loader false
          dispatch({ type: "IS_LOADER", data: false });
        })
        .catch((error) => {
          //Loader false
          dispatch({ type: "IS_LOADER", data: false });
          reject(error);
        });
    });
  };
};

export const getApplicationUsers = () => {
  return (dispatch) => {
    //Loader true
    dispatch({ type: "IS_LOADER", data: true });
    Actions.GET(`${API.GET_APPLICATION_USERS_LIST}`)
      .then((res) => {
        if (res.data !== undefined) {
          dispatch({
            type: "APPLICATION_USERS_LOADED_SUCCESS",
            data: res.data,
          });
        }
        //Loader false
        dispatch({ type: "IS_LOADER", data: false });
      })
      .catch((error) => {
        //Loader false
        dispatch({ type: "IS_LOADER", data: false });
      });
  };
};

export const purchaseLicense = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      //Loader true
      dispatch({ type: "IS_LOADER", data: true });
      Actions.PUT(`${API.PUT_LICENSE}`, data)
        .then((res) => {
          if (res.data !== undefined) {
            dispatch({
              type: "APPLICATION_PURCHASE_LICENSE_LOADED_SUCCESS",
              data: {},
            });
            resolve(res.data);
          } else {
            reject(new Error("No data in response"));
          }
          //Loader false
          dispatch({ type: "IS_LOADER", data: false });
        })
        .catch((error) => {
          console.log("error", error);
          //Loader false
          dispatch({ type: "IS_LOADER", data: false });
          reject(error);
        });
    });
  };
};

export const mapUser = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      //Loader true
      dispatch({ type: "IS_LOADER", data: true });
      Actions.POST(`${API.POST_ROLE_USER}`, data)
        .then((res) => {
          if (res.data !== undefined) {
            dispatch({ type: "ROLE_USER_ADDED_SUCCESS", data: {} });

            resolve(res.data);
          } else {
            reject(new Error("No data in response"));
          }
          //Loader false
          dispatch({ type: "IS_LOADER", data: false });
        })
        .catch((error) => {
          console.log("error", error);
          //Loader false
          dispatch({ type: "IS_LOADER", data: false });
          reject(error);
        });
    });
  };
};

export const deleteMappedUser = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      //Loader true
      dispatch({ type: "IS_LOADER", data: true });
      Actions.DELETE(`${API.DELETE_ROLE_USER}`, data)
        .then((res) => {
          if (res.data !== undefined) {
            dispatch({ type: "ROLE_USER_DELETED_SUCCESS", data: {} });

            resolve(res.data);
          } else {
            reject(new Error("No data in response"));
          }
          //Loader false
          dispatch({ type: "IS_LOADER", data: false });
        })
        .catch((error) => {
          console.log("error", error);
          //Loader false
          dispatch({ type: "IS_LOADER", data: false });
          reject(error);
        });
    });
  };
};
